import Raven from 'raven-js';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { uploadFile } from '../../draft-transplant/api/FileManagerApi';
import { getSignedSrc } from '../../draft-transplant/utils/Images';
import { HIDDEN_IN_APP_PRIVATE_NOT_INDEXABLE } from '../../draft-transplant/utils/constants';
import { EditorConfigContext } from '../contexts/EditorConfigContext';
import { INLINE_IMAGE } from '../editorCapabilities/constants';
export function useImageUploadHandler(props) {
  var _editorConfig$INLINE_, _editorConfig$INLINE_2, _editorConfig$INLINE_3;
  const {
    updateImage,
    attrs
  } = props;
  const editorConfig = useContext(EditorConfigContext);
  const preserveFileManagerId = (_editorConfig$INLINE_ = (_editorConfig$INLINE_2 = editorConfig[INLINE_IMAGE]) === null || _editorConfig$INLINE_2 === void 0 ? void 0 : _editorConfig$INLINE_2.preserveFileManagerId) !== null && _editorConfig$INLINE_ !== void 0 ? _editorConfig$INLINE_ : false;
  const customUploadImage = (_editorConfig$INLINE_3 = editorConfig[INLINE_IMAGE]) === null || _editorConfig$INLINE_3 === void 0 ? void 0 : _editorConfig$INLINE_3.uploadImage;
  const [progress, setProgress] = useState(null);
  const [signedUrl, setSignedUrl] = useState(null);
  const [fileManagerId, setFileManagerId] = useState(null);
  useEffect(() => {
    if (signedUrl && attrs.src !== signedUrl) {
      updateImage({
        image: {
          src: signedUrl,
          isTemporary: false,
          uploadPercent: 100,
          fileToUpload: null,
          fileManagerId: preserveFileManagerId ? fileManagerId : null
        }
      });
    } else if (!signedUrl && progress && attrs.uploadPercent !== progress) {
      updateImage({
        image: {
          uploadPercent: progress
        }
      });
    }
  }, [progress, signedUrl, fileManagerId, preserveFileManagerId, updateImage, attrs]);
  const onProgress = useCallback(progressData => {
    if (!progressData.lengthComputable) {
      return;
    }
    const percentComplete = parseInt(`${progressData.loaded / progressData.total}`, 10) * 100;
    setProgress(percentComplete);
  }, [setProgress]);
  const hasStartedUpload = useRef(false);
  useEffect(() => {
    if (hasStartedUpload.current) return;
    if (attrs.isTemporary && attrs.fileToUpload) {
      hasStartedUpload.current = true;
      const uploadFn = customUploadImage || uploadFile;
      uploadFn(attrs.fileToUpload, {
        access: attrs.fileManagerAccess || HIDDEN_IN_APP_PRIVATE_NOT_INDEXABLE,
        folderPath: attrs.folderPath,
        onProgress
      }).then(data => {
        const {
          id
        } = data.objects[0];
        const imageUrl = customUploadImage ? id : getSignedSrc(id);
        setFileManagerId(customUploadImage ? null : id);
        setSignedUrl(imageUrl);
      }).catch(error => {
        console.warn('Failed to upload file');
        Raven.captureException(error);
      });
    }
  }, [attrs, onProgress, customUploadImage]);
}